export default __webpack_public_path__ + "static/media/unauthorized.36dde6f5.svg";